// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HistogramImage__histogram-db8dcd {
  color: var(--outgoing-bubble-text_70);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/Appearance/AppearanceExample/HistogramImage/HistogramImage.styles.m.css"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF","sourcesContent":[".histogram {\n  color: var(--outgoing-bubble-text_70);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"histogram": `HistogramImage__histogram-db8dcd`
};
module.exports = ___CSS_LOADER_EXPORT___;
